
import { defineComponent, PropType } from 'vue'
import { RepositoryScaTargetReportItem, ReportLevel } from '~/types/types'
import {
  CompiledPinnedReportT,
  ILoadingValue,
  IReportMetadata,
  ReportPageT
} from '~/types/reportTypes'

type Target = Pick<
  RepositoryScaTargetReportItem,
  | 'id'
  | 'repository'
  | 'packageManager'
  | 'manifestPath'
  | 'lockfilePath'
  | 'criticalSeverityVulnerabilityCount'
  | 'highSeverityVulnerabilityCount'
  | 'mediumSeverityVulnerabilityCount'
  | 'lowSeverityVulnerabilityCount'
>

export default defineComponent({
  name: 'PinnedRecentlyUpdatedTargetsList',
  props: {
    allowPinningReports: {
      type: Boolean,
      required: true
    },
    loadingValue: {
      type: Object as PropType<ILoadingValue>,
      required: true
    },
    targetsList: {
      type: Array as PropType<Array<Target>>,
      default: () => []
    },
    metadata: {
      type: [Object, null] as PropType<IReportMetadata | null>,
      default: null
    },
    owner: {
      type: String,
      required: true
    },
    pinnedReports: {
      type: Array as PropType<Array<CompiledPinnedReportT>>,
      required: true
    },
    provider: {
      type: String,
      required: true
    },
    reportKey: {
      type: String as PropType<ReportPageT>,
      required: true
    },
    reportSlot: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loaderCount: 5,
      revealReportControls: false,
      ReportLevel,
      timeoutId: null as ReturnType<typeof setTimeout> | null
    }
  },
  methods: {
    hideReportControls(): void {
      this.timeoutId = setTimeout(() => {
        this.revealReportControls = false
      }, 1000)
    },

    navigateToReportPage(): void {
      const reportPageUrl = this.$generateRoute(['reports', 'sca-targets'], false, true)
      this.$router.push(reportPageUrl)
    },

    showReportControls(): void {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
      this.revealReportControls = true
    }
  },
  computed: {
    currentSelection(): string {
      const currentSelection = this.metadata?.filter || this.reportKey

      if (this.loadingValue.status || !currentSelection) {
        return ''
      }
      return this.metadata?.filter || this.reportKey
    },
    helpText(): string {
      return ''
    }
  }
})
